import React, { useEffect, useState } from "react";

const WORDS = [
  "Josh",
  "optimizing...",
  "discombobulating...",
  "building...",
  "vibing..."
];

const TYPE_SPEED = 90;
const DELETE_SPEED = 45;
const PAUSE_AFTER_TYPE = 1400;
const PAUSE_AFTER_DELETE = 300;

export default function Typewriter() {
  const [wordIndex, setWordIndex] = useState(0);
  const [text, setText] = useState("");
  const [phase, setPhase] = useState("typing");

  useEffect(() => {
    const currentWord = WORDS[wordIndex];
    let timeout;

    if (phase === "typing") {
      if (text.length < currentWord.length) {
        timeout = setTimeout(() => setText(currentWord.slice(0, text.length + 1)), TYPE_SPEED);
      } else {
        const pause = currentWord === "Josh" ? 3000 : PAUSE_AFTER_TYPE;
        timeout = setTimeout(() => setPhase("deleting"), pause);
      }
    } else {
      if (text.length > 0) {
        timeout = setTimeout(() => setText(text.slice(0, -1)), DELETE_SPEED);
      } else {
        timeout = setTimeout(() => {
          setWordIndex((i) => (i + 1) % WORDS.length);
          setPhase("typing");
        }, PAUSE_AFTER_DELETE);
      }
    }

    return () => clearTimeout(timeout);
  }, [text, phase, wordIndex]);

  return (
    <span>
      {text}
      <span className="inline-block w-[3px] h-[0.85em] bg-amber-500 ml-1 align-middle animate-pulse" />
    </span>
  );
}
